export default "__VITE_ASSET__cca2cd97__"